import * as React from "react";
const SvgEllipse10 = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7.5, stroke: "black", strokeOpacity: 0.29, strokeDasharray: "2 2" }));
export default SvgEllipse10;
